<template>
  <section>
    <section-header @toggle="showSection = !showSection" :showSection="showSection">
      <slot></slot>
    </section-header>

    <div class="content" v-show="showSection">
      <div v-for="attribute in item.attributes" :key="attribute.name">
        <fifth-edition
          v-if="['5th Edition', '5e24', 'Solarian Conflict'].includes(item.ruleset)"
          :name="attribute.name"
          :attribute="attribute"
        ></fifth-edition>
        <pfrpg
          v-if="['PFRPG', 'PFRPG2', 'PF Playtest', 'Embers RPG'].includes(item.ruleset)"
          :name="attribute.name"
          :attribute="attribute"
        ></pfrpg>
        <savage-worlds
          v-if="['Savage Embers', 'Savage Worlds'].includes(item.ruleset)"
          :name="attribute.name"
          :attribute="attribute"
          :ruleset="item.ruleset"
        ></savage-worlds>
      </div>
    </div>
  </section>
</template>
<script>
import FifthEdition from "./_5thEdition.vue";
import Pfrpg from "./_Pfrpg.vue";
import SavageWorlds from "./_SavageWorlds.vue";
import SectionHeader from "../shared/_SectionHeader.vue";
import { mapState } from "vuex";

export default {
  name: "sheet-attributes-index",
  components: {
    FifthEdition,
    Pfrpg,
    SectionHeader,
    SavageWorlds,
  },
  data() {
    return {
      showSection: true,
    };
  },
  computed: mapState({
    item: (state) => state.characters.current,
  }),
};
</script>
